import { ref } from 'vue'

const isSearchOverlayVisible = ref(false)

export const useSearchOverlay = () => {
  const showSearchOverlay = () => {
    isSearchOverlayVisible.value = true
  }

  const hideSearchOverlay = () => {
    isSearchOverlayVisible.value = false
  }

  return {
    isSearchOverlayVisible,
    showSearchOverlay,
    hideSearchOverlay,
  }
}
